module.exports = __webpack_public_path__ + "static/media/indexbg.30d6d308.jpg";